<div class="modal-content text-center">
  <div class="spinner-wrapper" *ngIf="isLoading">
    <mat-spinner></mat-spinner>
  </div>
  <button aria-label="Close" class="close" (click)="activeModal.dismiss()" type="button">
    <span class="fas fa-times"></span>
  </button>
  <div class="onboarding-content">
    <h4 class="onboarding-title">
      <ng-template [ngIf]="!editTimeFilterData">{{
        'ResSettings.ResAddTimeFilter.NewTimeRange' | translate
      }}</ng-template>
      <ng-template [ngIf]="editTimeFilterData">
        {{ 'ResSettings.ResAddTimeFilter.EditTimeRange' | translate }}</ng-template
      >
    </h4>
    <form [formGroup]="resTimeFilterFormGroup">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label for=""> Name</label>
            <input class="form-control" placeholder="" type="text" formControlName="name" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for=""> {{ 'ResSettings.ResAddTimeFilter.StartTime' | translate }}</label>
            <ngb-timepicker formControlName="from" [meridian]="false"></ngb-timepicker>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="">{{ 'ResSettings.ResAddTimeFilter.EndTime' | translate }}</label>
            <ngb-timepicker formControlName="to" [meridian]="false"></ngb-timepicker>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for=""> Nach Status filtern </label>
            <ng-select
              [searchable]="false"
              [clearable]="true"
              formControlName="status"
              placeholder="-- Status auswählen --"
              [items]="allStatus"
              bindLabel="label"
              bindValue="value"
              groupBy="type"
            >
              <ng-template ng-label-tmp let-item="item">
                <span [class]="item.icon"></span>
                {{ item.label }}
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-index="index">
                <span *ngIf="item.type === 'single'">Einzelne</span>
                <span *ngIf="item.type === 'group'">Gruppiert</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <span [class]="item.icon"></span>
                {{ item.label }}
                <small *ngIf="item.description" style="display:block">{{ item.description }}</small>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for=""> Nach Schicht filtern </label>
            <ng-select
              [searchable]="false"
              [clearable]="true"
              formControlName="shiftId"
              placeholder="-- Schicht auswählen --"
            >
              <ng-option [value]="shift.id" *ngFor="let shift of shifts">{{ shift.name }}</ng-option>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="form-group">
            <label for=""> Nach Raum filtern </label>
            <ng-select
              [searchable]="false"
              [clearable]="true"
              formControlName="roomIds"
              [multiple]="true"
              placeholder="-- Raum auswählen --"
            >
              <ng-option [value]="room.id" *ngFor="let room of rooms">{{ room.name }}</ng-option>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="form-group">
            <label for=""> Nach Tags von heute filtern </label>
            <ng-select
              [items]="allTags"
              [hideSelected]="true"
              multiple="true"
              bindLabel="label"
              placeholder="-- Tags auswählen --"
              formControlName="tagIds"
            >
              <ng-template ng-label-tmp let-item="item" let-clear="clear">
                <span class="ng-value-label">
                  <i class="fas fa-circle" [style.color]="item.color"></i>
                  {{ item.label }}
                </span>
                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
              </ng-template>

              <ng-template ng-option-tmp let-item="item">
                <i class="fas fa-circle" [style.color]="item.color" *ngIf="item.color"></i> {{ item.label }}
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
      <button class="btn btn-primary btn-block btn-lg" (click)="add()">
        {{ 'ResSettings.ResAddTimeFilter.Save' | translate }}
      </button>
    </form>
  </div>
</div>
